module.exports = __webpack_public_path__ + "img/19_Antrum.864afa07.png";